import { RegistrationItem } from './registration-item.model';

/**
 * holds item's sub totals and discounts
 */
export class EventItemTotal {
  public EventItem: RegistrationItem;

  /**
   * total for item (quantity * price)
   */
  public ItemTotal: number = 0;
  public AdditionalCost: number = 0;
  public DiscountTotal: number = 0;
  public Total: number = 0;
}
